<script lang="ts">
    import { Button } from "sveltestrap";
    import { ThirdLicense as ThirdLicenseModel } from "../Model/ThirdLicense";
    import { thirdLicenseService } from "../services";
    import ParamName from "./ParamName.svelte";
    import { v4 as uuidv4 } from "uuid";
    import ThirdLicenseModal from "./ThirdLicenseModal.svelte";
    import { dateLocalInputFormatter } from "../services/Functions";
    import ThirdLicense from "./ThirdLicense.svelte";

    export let thirdId: string;
    export let userModal: boolean = true;

    let licenses: ThirdLicenseModel[];

    let editLicense = null;
    let licenseEdit = null;
    let removeButton: boolean;
    let cancelButton: boolean;

    $: loadLicenses();

    async function loadLicenses() {
        licenses = await thirdLicenseService.getThirdLicensByThirdId(thirdId);
        
    }

    function openModal(license: ThirdLicenseModel = null){
        if(license == null) {
            removeButton = false;
            editLicense = new ThirdLicenseModel({
                id: uuidv4(),
                third_id: thirdId,
                license_type: '',
                exp_date: new Date().toISOString()
            })
        } else {
            removeButton = true;
            editLicense = license;
        }
    }

    function showEditLicense(license: ThirdLicenseModel = null) {
        if(license == null && !licenseEdit) {
            removeButton = false;
            licenseEdit = new ThirdLicenseModel({
                id: uuidv4(),
                third_id: thirdId,
                license_type: '',
                exp_date: new Date().toISOString()
            })
        } else if(license && !licenseEdit) {
            removeButton = true;
            licenseEdit = license;
        } else if(license && licenseEdit) {
            licenseEdit = undefined;
        }
    }

    function addNewLicense (license){
        if (license == editLicense || license == licenseEdit) {

            let licenseObj = licenses.find(l => l.id == license.id)

            if (licenseObj) {
                licenseObj = license
            } else{
                licenses.push(license);
            }

            editLicense = null
            licenseEdit = null
            license = null
            licenses = licenses;
        }
        
    }

    function removeLicense (license){
        if (license == editLicense  || license == licenseEdit) {

            licenses.splice(licenses.findIndex((elemento, indice) => {
                if (elemento.id === license.id) {
                    return indice;
                }
            }), 1);

            editLicense = null
            licenseEdit = null

            licenses = licenses;
            
        }
        
    }

</script>

<div class="row">
    <div class="col-8 mb-3">
        <h5>Listado</h5>
    </div>
    <div class="col-4 mb-3">
        <div class="text-end">
            <Button color="primary" on:click={() => {
                if(!userModal) {
                    showEditLicense();
                } else {
                    openModal()
                }
            }}>
               Nuevo permiso
            </Button>
        </div>
    </div>

    <div class='col-12'>
        {#if licenses && licenses.length > 0}
            <ul>
                {#each licenses as license}
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <li class='flex'>
                        <div on:click={() => {
                            if(!userModal) {
                                showEditLicense(license);
                            } else {
                                openModal(license)
                            }
                        }}>
                            <span class='link-primary' style="cursor: pointer;">
                                <ParamName id={license.license_type}/>
                                ({license.exp_date ? 'validez ' + dateLocalInputFormatter(license.exp_date) : 'sin fecha de validez'})
                            </span>
                        </div>
                    </li>
                {/each}
            </ul>
        {:else}
            <div class="text-center">
                <h5>No hay permisos para mostrar</h5>
            </div>
        {/if}
    </div>
</div>

<ThirdLicense 
    bind:license={licenseEdit} 
    bind:removeButton
    on:addLicense={(event) => addNewLicense(event.detail)}
    on:removeLicense={(event) => removeLicense(event.detail)}
/>

<ThirdLicenseModal 
    bind:license={editLicense} 
    bind:removeButton
    on:addLicense={(event) => addNewLicense(event.detail)}
    on:removeLicense={(event) => removeLicense(event.detail)}
/>